const loginPageStyle = (theme) => ({
  pageHeader: {
    minHeight: '100vh',
    height: 'auto',
    display: 'flex',
    position: 'relative',
    margin: '-8px',
    padding: '0',
    border: '0',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1A0F3B',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflowX: 'hidden',
    overflowY: 'auto',
    '&:before': {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      inset: 0,
      background:
        'linear-gradient(160deg, rgba(26,15,59,0.55) 0%, rgba(18,10,42,0.35) 45%, rgba(26,15,59,0.65) 100%)',
    },
  },
  langPillWrap: {
    position: 'absolute',
    top: '22px',
    right: '28px',
    zIndex: 5,
    [theme.breakpoints.down('sm')]: {
      top: '16px',
      right: '16px',
    },
  },
  langPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '8px 14px',
    borderRadius: '999px',
    cursor: 'pointer',
    background: 'rgba(26, 15, 59, 0.45)',
    border: '1px solid rgba(251, 250, 254, 0.35)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    color: '#FBFAFE',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 500,
    userSelect: 'none',
  },
  langMenu: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    right: 0,
    minWidth: '140px',
    margin: 0,
    padding: '6px 0',
    listStyle: 'none',
    borderRadius: '12px',
    background: 'rgba(26, 15, 59, 0.92)',
    border: '1px solid rgba(118, 40, 255, 0.35)',
    boxShadow: '0 12px 28px rgba(0,0,0,0.35)',
    zIndex: 10,
  },
  langMenuItem: {
    padding: '10px 14px',
    color: '#EBE7FB',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '13px',
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(100, 17, 237, 0.28)',
      color: '#FFFFFF',
    },
  },
  container: {
    zIndex: 2,
    position: 'relative',
    width: '100%',
    maxWidth: '420px',
    padding: '100px 20px 48px',
    margin: '0 auto',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: '88px 16px 40px',
    },
  },
  containerWide: {
    zIndex: 2,
    position: 'relative',
    width: '100%',
    maxWidth: '760px',
    padding: '80px 14px 36px',
    margin: '0 auto',
    boxSizing: 'border-box',
    '@media (min-width: 600px)': {
      padding: '96px 28px 52px',
    },
  },
  glassCard: {
    position: 'relative',
    borderRadius: '22px',
    padding: '26px 16px 20px',
    background:
      'linear-gradient(165deg, rgba(44,25,91,0.62) 0%, rgba(26,15,59,0.72) 48%, rgba(18,10,42,0.78) 100%)',
    border: '1px solid rgba(215, 207, 235, 0.22)',
    boxShadow:
      '0 32px 72px rgba(0,0,0,0.48), 0 0 56px rgba(100, 17, 237, 0.22), inset 0 1px 0 rgba(255,255,255,0.16)',
    backdropFilter: 'blur(28px)',
    WebkitBackdropFilter: 'blur(28px)',
    overflow: 'hidden',
    '@media (min-width: 600px)': {
      borderRadius: '28px',
      padding: '36px 36px 28px',
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '10%',
      right: '10%',
      height: '2px',
      background:
        'linear-gradient(90deg, transparent, rgba(118,40,255,0.95), rgba(251,250,254,0.75), rgba(118,40,255,0.95), transparent)',
      boxShadow: '0 0 20px rgba(118, 40, 255, 0.75)',
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      background:
        'radial-gradient(ellipse 70% 40% at 50% -10%, rgba(118,40,255,0.22), transparent 60%)',
    },
    /* Sin subrayados de MUI Input en el formulario de registro */
    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    /* Texto claro sobre fondo glass oscuro */
    '& .MuiInputBase-input, & .MuiSelect-select, & input, & textarea': {
      color: '#FBFAFE !important',
      WebkitTextFillColor: '#FBFAFE !important',
      caretColor: '#FBFAFE',
    },
    /* El autocompletado del navegador pinta fondo claro: sin esto el texto blanco queda invisible */
    '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
      WebkitTextFillColor: '#FBFAFE !important',
      caretColor: '#FBFAFE',
      boxShadow: '0 0 0 1000px rgba(32, 20, 72, 0.96) inset !important',
      WebkitBoxShadow: '0 0 0 1000px rgba(32, 20, 72, 0.96) inset !important',
      transition: 'background-color 99999s ease-in-out 0s',
    },
    '& input:autofill': {
      boxShadow: '0 0 0 1000px rgba(32, 20, 72, 0.96) inset !important',
    },
    '& .MuiInputBase-input.Mui-disabled, & .MuiSelect-select.Mui-disabled, & .Mui-disabled .MuiSelect-select': {
      color: 'rgba(251,250,254,0.78) !important',
      WebkitTextFillColor: 'rgba(251,250,254,0.78) !important',
      opacity: '1 !important',
      '-webkit-text-fill-color': 'rgba(251,250,254,0.78) !important',
    },
    '& .MuiFormLabel-root, & .MuiInputLabel-root, & label': {
      color: 'rgba(251,250,254,0.78) !important',
    },
    '& .MuiFormLabel-root.Mui-focused, & .MuiInputLabel-root.Mui-focused': {
      color: '#D7CFEB !important',
    },
    '& .MuiFormLabel-root.Mui-disabled': {
      color: 'rgba(251,250,254,0.55) !important',
    },
    '& .MuiSelect-icon': {
      color: '#D7CFEB !important',
    },
    '& .Mui-disabled .MuiSelect-icon': {
      color: 'rgba(215,207,235,0.45) !important',
    },
    '& .MuiTypography-root': {
      color: 'inherit',
    },
    '& .MuiFormHelperText-root, & .MuiTypography-caption': {
      color: '#D7CFEB',
    },
  },
  logoWrap: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '18px',
  },
  logoBadge: {
    width: '72px',
    height: '72px',
    borderRadius: '18px',
    padding: '5px',
    background: 'linear-gradient(145deg, #2C195B, #1A0F3B)',
    border: '2px solid rgba(118, 40, 255, 0.9)',
    boxShadow:
      '0 0 28px rgba(100, 17, 237, 0.6), 0 0 48px rgba(118, 40, 255, 0.28), inset 0 1px 0 rgba(255,255,255,0.18)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    '@media (min-width: 600px)': {
      width: '80px',
      height: '80px',
      borderRadius: '20px',
    },
  },
  logoImg: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: '13px',
  },
  form: {
    position: 'relative',
    zIndex: 1,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  glassInput: {
    flex: 1,
    minWidth: 0,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    color: '#FBFAFE',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '15px',
    fontWeight: 500,
    padding: '15px 0',
    caretColor: '#FBFAFE',
    '&::placeholder': {
      color: 'rgba(251, 250, 254, 0.52)',
      opacity: 1,
    },
    /* Chrome/Edge autofill & paste highlight: keep dark field + white text */
    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
      WebkitTextFillColor: '#FBFAFE !important',
      caretColor: '#FBFAFE',
      boxShadow: '0 0 0 1000px rgba(18, 10, 42, 0.95) inset !important',
      WebkitBoxShadow: '0 0 0 1000px rgba(18, 10, 42, 0.95) inset !important',
      transition: 'background-color 99999s ease-in-out 0s',
      borderRadius: '8px',
    },
    '&:autofill': {
      color: '#FBFAFE !important',
      boxShadow: '0 0 0 1000px rgba(18, 10, 42, 0.95) inset !important',
    },
  },
  glassField: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minHeight: '52px',
    padding: '0 14px',
    borderRadius: '14px',
    background: 'linear-gradient(180deg, rgba(44,25,91,0.58) 0%, rgba(18,10,42,0.78) 100%)',
    border: '1px solid rgba(215, 207, 235, 0.2)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.09), 0 6px 16px rgba(0,0,0,0.14)',
    boxSizing: 'border-box',
    width: '100%',
    transition: 'border-color 0.18s ease, box-shadow 0.18s ease',
    '@media (min-width: 600px)': {
      minHeight: '54px',
      padding: '0 16px',
      borderRadius: '16px',
      gap: '12px',
    },
    '&:focus-within': {
      borderColor: 'rgba(118, 40, 255, 0.8)',
      boxShadow:
        '0 0 0 1px rgba(118, 40, 255, 0.45), 0 10px 28px rgba(100,17,237,0.24), inset 0 1px 0 rgba(255,255,255,0.12)',
    },
  },
  glassFieldIcon: {
    color: 'rgba(215,207,235,0.92) !important',
    fontSize: '20px !important',
    opacity: 0.9,
    flexShrink: 0,
  },
  signupTitle: {
    position: 'relative',
    zIndex: 1,
    color: '#FBFAFE',
    fontSize: 22,
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontWeight: 800,
    textAlign: 'center',
    margin: '0 0 4px',
    letterSpacing: '0.3px',
    '@media (min-width: 600px)': {
      fontSize: 26,
    },
  },
  signupSubtitle: {
    position: 'relative',
    zIndex: 1,
    color: 'rgba(251,250,254,0.58)',
    fontSize: 13,
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontWeight: 500,
    textAlign: 'center',
    margin: '0 0 16px',
    lineHeight: 1.45,
  },
  signupSection: {
    margin: 0,
    padding: '12px 0 0',
    border: 'none',
    borderTop: '1px solid rgba(215, 207, 235, 0.12)',
    minWidth: 0,
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '10px',
    '&:first-of-type': {
      borderTop: 'none',
      paddingTop: 0,
    },
    '@media (min-width: 700px)': {
      gridColumn: '1 / -1',
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
      columnGap: '14px',
      rowGap: '12px',
      paddingTop: '14px',
      '&:first-of-type': {
        paddingTop: 0,
      },
    },
  },
  signupSectionTitle: {
    gridColumn: '1 / -1',
    float: 'none',
    width: '100%',
    margin: '0 0 2px',
    padding: '0 2px',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '1.4px',
    textTransform: 'uppercase',
    color: 'rgba(215,207,235,0.72)',
  },
  signupGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    boxSizing: 'border-box',
    '@media (min-width: 700px)': {
      gap: '6px',
    },
  },
  signupFieldFull: {
    gridColumn: '1 / -1',
  },
  glassSelect: {
    flex: 1,
    minWidth: 0,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    color: '#FBFAFE',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '15px',
    fontWeight: 500,
    padding: '15px 0',
    margin: 0,
    cursor: 'pointer',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    '&:disabled': {
      opacity: 0.75,
      cursor: 'not-allowed',
    },
    '& option': {
      backgroundColor: '#1A0F3B',
      color: '#FBFAFE',
    },
  },
  signupHint: {
    margin: '0',
    padding: '0 4px',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '12px',
    lineHeight: 1.4,
    color: '#D7CFEB',
    gridColumn: '1 / -1',
  },
  signupHintError: {
    color: '#FF8A80',
  },
  eyeBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'rgba(215,207,235,0.85)',
    padding: '4px',
    border: 'none',
    background: 'transparent',
    flexShrink: 0,
  },
  loginBtn: {
    margin: '4px 0 0 !important',
    width: '100% !important',
    maxWidth: '100%',
    alignSelf: 'stretch',
    boxSizing: 'border-box',
    minHeight: '52px',
    borderRadius: '999px !important',
    border: 'none !important',
    textTransform: 'uppercase !important',
    fontFamily: "'Outfit', 'Poppins', sans-serif !important",
    fontWeight: '800 !important',
    fontSize: '14px !important',
    letterSpacing: '1.2px',
    color: '#FFFFFF !important',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    display: 'flex !important',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: '10px',
    background:
      'linear-gradient(105deg, #2C195B 0%, #46159D 22%, #6411ED 48%, #7628FF 72%, #3B2275 100%) !important',
    boxShadow:
      '0 12px 32px rgba(100, 17, 237, 0.5), inset 0 1px 0 rgba(255,255,255,0.28), inset 0 -2px 8px rgba(10,6,24,0.28) !important',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '46%',
      background:
        'linear-gradient(180deg, rgba(251,250,254,0.28) 0%, rgba(251,250,254,0) 100%)',
      pointerEvents: 'none',
    },
    '&:hover': {
      background:
        'linear-gradient(105deg, #221448 0%, #3B2275 22%, #5B0FD9 48%, #6D1FF0 72%, #2C195B 100%) !important',
    },
    '&:disabled': {
      opacity: 0.7,
      cursor: 'default',
    },
  },
  loginBtnArrow: {
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    background:
      'linear-gradient(145deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.08) 100%)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    position: 'relative',
    zIndex: 1,
  },
  secondaryBtn: {
    width: '100% !important',
    maxWidth: '100%',
    alignSelf: 'stretch',
    boxSizing: 'border-box',
    minHeight: '44px',
    borderRadius: '999px',
    border: '1px solid rgba(215, 207, 235, 0.32)',
    background: 'rgba(18, 10, 42, 0.28)',
    color: '#EBE7FB',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontWeight: 600,
    fontSize: '13px',
    letterSpacing: '0.6px',
    cursor: 'pointer',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    margin: '0',
    padding: '0 16px',
    '&:hover': {
      background: 'rgba(100, 17, 237, 0.22)',
      borderColor: 'rgba(118, 40, 255, 0.5)',
    },
  },
  forgotLink: {
    alignSelf: 'center',
    background: 'none',
    border: 'none',
    color: '#D7CFEB',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '13px',
    cursor: 'pointer',
    padding: '4px 8px',
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
    '&:hover': {
      color: '#7628FF',
    },
  },
  dividerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    margin: '10px 0 4px',
  },
  dividerLine: {
    flex: 1,
    height: '1px',
    background: 'rgba(215, 207, 235, 0.28)',
  },
  dividerDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: 'rgba(118, 40, 255, 0.7)',
    boxShadow: '0 0 8px rgba(118, 40, 255, 0.55)',
    flexShrink: 0,
  },
  socialRow: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    alignItems: 'stretch',
    width: '100%',
    minHeight: '52px',
  },
  socialBtn: {
    flex: '1 1 0',
    minWidth: 0,
    height: '52px',
    minHeight: '52px',
    borderRadius: '999px',
    border: '1px solid rgba(251, 250, 254, 0.28)',
    background: 'rgba(18, 10, 42, 0.4)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxSizing: 'border-box',
    padding: 0,
    margin: 0,
    transition: 'background 0.2s ease, border-color 0.2s ease',
    '&:hover': {
      background: 'rgba(100, 17, 237, 0.2)',
      borderColor: 'rgba(118, 40, 255, 0.55)',
    },
  },
  socialGoogleIcon: {
    display: 'block',
    width: 28,
    height: 28,
    flexShrink: 0,
  },
  registerRow: {
    marginTop: '18px',
    textAlign: 'center',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '14px',
    color: 'rgba(251, 250, 254, 0.85)',
  },
  registerLink: {
    background: 'none',
    border: 'none',
    padding: 0,
    marginLeft: '6px',
    cursor: 'pointer',
    color: '#7628FF',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '14px',
    fontWeight: 700,
    textDecoration: 'none',
    '&:hover': {
      color: '#9F5CFF',
      textDecoration: 'underline',
    },
  },
  loadingWrap: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px 0',
  },
  countryWrap: {
    marginBottom: '0',
    marginTop: '0',
    '& .MuiFormControl-root': {
      margin: '0 0 17px 0',
      paddingTop: '27px',
      width: '100%',
    },
    '& .MuiInputBase-root, & .MuiInput-root': {
      color: '#FBFAFE !important',
    },
    '& label, & .MuiFormLabel-root, & .MuiInputLabel-root': {
      color: 'rgba(251,250,254,0.85) !important',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: '14px !important',
      fontWeight: '400 !important',
      left: '0 !important',
      top: '10px',
    },
    '& .MuiInputLabel-shrink': {
      color: 'rgba(251,250,254,0.7) !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: '1px solid #FFFFFF !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid #FFFFFF !important',
    },
    '& .MuiInput-underline:after': {
      borderBottom: '2px solid #FFFFFF !important',
    },
    '& .MuiInputBase-input': {
      color: '#FBFAFE !important',
      WebkitTextFillColor: '#FBFAFE !important',
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '14px !important',
      paddingLeft: '0 !important',
      marginLeft: '0 !important',
    },
  },
  // Una sola sangría izquierda para toda la columna del registro
  signupFields: {
    '& .MuiFormControl-root': {
      marginLeft: '0 !important',
      marginRight: '0 !important',
      width: '100%',
    },
    '& .MuiInputLabel-root': {
      left: '0 !important',
      paddingLeft: '0 !important',
      marginLeft: '0 !important',
    },
    '& .MuiInputBase-input, & .MuiSelect-select, & input': {
      paddingLeft: '0 !important',
      marginLeft: '0 !important',
      marginRight: '0 !important',
      boxSizing: 'border-box',
    },
    '& .MuiInputAdornment-root': {
      marginLeft: '0 !important',
      marginRight: '0 !important',
    },
  },
  // Keep legacy keys used by signup form during transition
  cardHeader: {
    width: 'auto',
    textAlign: 'center',
    marginLeft: '0',
    marginRight: '0',
    marginTop: '0',
    padding: '12px 0 8px',
    marginBottom: '8px',
    background: 'transparent !important',
    boxShadow: 'none !important',
  },
  cardFooter: {
    position: 'relative',
    zIndex: 1,
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'stretch !important',
    justifyContent: 'center !important',
    gap: '10px',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    /* Anula padding lateral del CardFooter base (1.875rem) que descentra en móvil */
    padding: '14px 0 4px !important',
    margin: '0',
    border: '0',
    borderRadius: '6px',
  },
  socialLine: {
    marginTop: '0.5rem',
    textAlign: 'center',
    padding: '0',
  },
  inputIconsColor: {
    color: '#D7CFEB',
  },
  normalButton: {
    margin: 0,
  },
  // Réplica exacta de CustomInput (formControl + labelRoot + whiteUnderline)
  selectFormControl: {
    margin: '0 0 17px 0',
    paddingTop: '27px',
    position: 'relative',
    width: '100%',
  },
  selectLabel: {
    color: 'rgba(251,250,254,0.85) !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    lineHeight: '1.42857',
    top: '10px',
    left: '0 !important',
    letterSpacing: 'unset',
    fontFamily: "'Outfit', 'Poppins', sans-serif !important",
    transformOrigin: 'top left',
    // Sin Typography anidada: mismo tamaño visual que CustomInput
    '& .MuiTypography-root': {
      fontSize: 'inherit !important',
      fontFamily: 'inherit !important',
      lineHeight: 'inherit',
      fontWeight: 'inherit',
    },
    '&.MuiInputLabel-shrink': {
      transform: 'translate(0, -1.5px) scale(0.75) !important',
      color: 'rgba(251,250,254,0.7) !important',
    },
    '&.Mui-focused': {
      color: 'rgba(251,250,254,0.85) !important',
    },
  },
  selectInputRoot: {
    color: '#FBFAFE !important',
    width: '100%',
  },
  selectUnderline: {
    '&:before': {
      borderBottom: '1px solid #FFFFFF !important',
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid #FFFFFF !important',
    },
    '&:after': {
      borderBottom: '2px solid #FFFFFF !important',
    },
    '&.Mui-disabled:before': {
      borderBottomStyle: 'solid',
      borderBottomColor: 'rgba(255,255,255,0.45) !important',
    },
  },
  selectField: {
    color: '#FBFAFE !important',
    width: '100%',
    '& .MuiSelect-select': {
      color: '#FBFAFE !important',
      WebkitTextFillColor: '#FBFAFE !important',
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '1.42857',
      paddingTop: '0 !important',
      paddingBottom: '7px !important',
      paddingLeft: '0 !important',
      paddingRight: '36px !important',
      marginLeft: '0 !important',
      marginRight: '0 !important',
      background: 'transparent !important',
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '&.Mui-disabled': {
      opacity: 1,
    },
    '&.Mui-disabled .MuiSelect-select': {
      color: 'rgba(251,250,254,0.78) !important',
      WebkitTextFillColor: 'rgba(251,250,254,0.78) !important',
    },
    '& .MuiSelect-icon': {
      color: '#D7CFEB !important',
      right: '0',
      top: 'calc(50% - 12px)',
    },
    '&.Mui-disabled .MuiSelect-icon': {
      color: 'rgba(215,207,235,0.45) !important',
    },
  },
  demoCard: {
    marginTop: '16px',
    borderRadius: '16px',
    padding: '12px 16px',
    background: 'rgba(18, 10, 42, 0.5)',
    border: '1px solid rgba(215, 207, 235, 0.25)',
    textAlign: 'center',
    color: '#EBE7FB',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '13px',
  },
});

export default loginPageStyle;
